// extracted by mini-css-extract-plugin
export default {"one-time":"OneTimePayment_one-time__hM-ht","one-time__countries":"OneTimePayment_one-time__countries__01M1l"};